/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeAutomationEmptyDto,
  ApiEnvelopeEventCatalogResponse,
  ApiEnvelopeEventExecutionListResponse,
  ApiEnvelopeEventHandlerDryRunResponse,
  ApiEnvelopeEventHandlerDto,
  ApiEnvelopeEventHandlerListResponse,
  EventHandlerDryRunRequest,
  EventHandlerExecutionsParams,
  EventHandlerRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type eventHandlerCatalogResponse200 = {
  data: ApiEnvelopeEventCatalogResponse
  status: 200
}

export type eventHandlerCatalogResponse403 = {
  data: ApiEnvelopeEventCatalogResponse
  status: 403
}

export type eventHandlerCatalogResponse404 = {
  data: ApiEnvelopeEventCatalogResponse
  status: 404
}

export type eventHandlerCatalogResponseSuccess = (eventHandlerCatalogResponse200) & {
  headers: Headers;
};
export type eventHandlerCatalogResponseError = (eventHandlerCatalogResponse403 | eventHandlerCatalogResponse404) & {
  headers: Headers;
};

export type eventHandlerCatalogResponse = (eventHandlerCatalogResponseSuccess | eventHandlerCatalogResponseError)

export const getEventHandlerCatalogUrl = (botId: string,) => {




  return `/api/bots/${botId}/automation/catalog`
}

export const useEventHandlerCatalogHook = (): (botId: string, options?: RequestInit) => Promise<eventHandlerCatalogResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getEventHandlerCatalogUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type eventHandlerListResponse200 = {
  data: ApiEnvelopeEventHandlerListResponse
  status: 200
}

export type eventHandlerListResponse403 = {
  data: ApiEnvelopeEventHandlerListResponse
  status: 403
}

export type eventHandlerListResponse404 = {
  data: ApiEnvelopeEventHandlerListResponse
  status: 404
}

export type eventHandlerListResponseSuccess = (eventHandlerListResponse200) & {
  headers: Headers;
};
export type eventHandlerListResponseError = (eventHandlerListResponse403 | eventHandlerListResponse404) & {
  headers: Headers;
};

export type eventHandlerListResponse = (eventHandlerListResponseSuccess | eventHandlerListResponseError)

export const getEventHandlerListUrl = (botId: string,) => {




  return `/api/bots/${botId}/automation`
}

export const useEventHandlerListHook = (): (botId: string, options?: RequestInit) => Promise<eventHandlerListResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getEventHandlerListUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type eventHandlerCreateResponse200 = {
  data: ApiEnvelopeEventHandlerDto
  status: 200
}

export type eventHandlerCreateResponse400 = {
  data: ApiEnvelopeEventHandlerDto
  status: 400
}

export type eventHandlerCreateResponse403 = {
  data: ApiEnvelopeEventHandlerDto
  status: 403
}

export type eventHandlerCreateResponse404 = {
  data: ApiEnvelopeEventHandlerDto
  status: 404
}

export type eventHandlerCreateResponseSuccess = (eventHandlerCreateResponse200) & {
  headers: Headers;
};
export type eventHandlerCreateResponseError = (eventHandlerCreateResponse400 | eventHandlerCreateResponse403 | eventHandlerCreateResponse404) & {
  headers: Headers;
};

export type eventHandlerCreateResponse = (eventHandlerCreateResponseSuccess | eventHandlerCreateResponseError)

export const getEventHandlerCreateUrl = (botId: string,) => {




  return `/api/bots/${botId}/automation`
}

export const useEventHandlerCreateHook = (): (botId: string,
    eventHandlerRequest?: EventHandlerRequest, options?: RequestInit) => Promise<eventHandlerCreateResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    eventHandlerRequest?: EventHandlerRequest, options?: RequestInit) => {

        return customFetcher(getEventHandlerCreateUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(eventHandlerRequest)
  }
);
      }
  }


export type eventHandlerUpdateResponse200 = {
  data: ApiEnvelopeEventHandlerDto
  status: 200
}

export type eventHandlerUpdateResponse400 = {
  data: ApiEnvelopeEventHandlerDto
  status: 400
}

export type eventHandlerUpdateResponse403 = {
  data: ApiEnvelopeEventHandlerDto
  status: 403
}

export type eventHandlerUpdateResponse404 = {
  data: ApiEnvelopeEventHandlerDto
  status: 404
}

export type eventHandlerUpdateResponseSuccess = (eventHandlerUpdateResponse200) & {
  headers: Headers;
};
export type eventHandlerUpdateResponseError = (eventHandlerUpdateResponse400 | eventHandlerUpdateResponse403 | eventHandlerUpdateResponse404) & {
  headers: Headers;
};

export type eventHandlerUpdateResponse = (eventHandlerUpdateResponseSuccess | eventHandlerUpdateResponseError)

export const getEventHandlerUpdateUrl = (botId: string,
    handlerId: string,) => {




  return `/api/bots/${botId}/automation/${handlerId}`
}

export const useEventHandlerUpdateHook = (): (botId: string,
    handlerId: string,
    eventHandlerRequest?: EventHandlerRequest, options?: RequestInit) => Promise<eventHandlerUpdateResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    handlerId: string,
    eventHandlerRequest?: EventHandlerRequest, options?: RequestInit) => {

        return customFetcher(getEventHandlerUpdateUrl(botId,handlerId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(eventHandlerRequest)
  }
);
      }
  }


export type eventHandlerDeleteResponse200 = {
  data: ApiEnvelopeAutomationEmptyDto
  status: 200
}

export type eventHandlerDeleteResponse403 = {
  data: ApiEnvelopeAutomationEmptyDto
  status: 403
}

export type eventHandlerDeleteResponse404 = {
  data: ApiEnvelopeAutomationEmptyDto
  status: 404
}

export type eventHandlerDeleteResponseSuccess = (eventHandlerDeleteResponse200) & {
  headers: Headers;
};
export type eventHandlerDeleteResponseError = (eventHandlerDeleteResponse403 | eventHandlerDeleteResponse404) & {
  headers: Headers;
};

export type eventHandlerDeleteResponse = (eventHandlerDeleteResponseSuccess | eventHandlerDeleteResponseError)

export const getEventHandlerDeleteUrl = (botId: string,
    handlerId: string,) => {




  return `/api/bots/${botId}/automation/${handlerId}`
}

export const useEventHandlerDeleteHook = (): (botId: string,
    handlerId: string, options?: RequestInit) => Promise<eventHandlerDeleteResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    handlerId: string, options?: RequestInit) => {

        return customFetcher(getEventHandlerDeleteUrl(botId,handlerId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type eventHandlerDryRunResponse200 = {
  data: ApiEnvelopeEventHandlerDryRunResponse
  status: 200
}

export type eventHandlerDryRunResponse403 = {
  data: ApiEnvelopeEventHandlerDryRunResponse
  status: 403
}

export type eventHandlerDryRunResponse404 = {
  data: ApiEnvelopeEventHandlerDryRunResponse
  status: 404
}

export type eventHandlerDryRunResponseSuccess = (eventHandlerDryRunResponse200) & {
  headers: Headers;
};
export type eventHandlerDryRunResponseError = (eventHandlerDryRunResponse403 | eventHandlerDryRunResponse404) & {
  headers: Headers;
};

export type eventHandlerDryRunResponse = (eventHandlerDryRunResponseSuccess | eventHandlerDryRunResponseError)

export const getEventHandlerDryRunUrl = (botId: string,) => {




  return `/api/bots/${botId}/automation/dry-run`
}

export const useEventHandlerDryRunHook = (): (botId: string,
    eventHandlerDryRunRequest?: EventHandlerDryRunRequest, options?: RequestInit) => Promise<eventHandlerDryRunResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    eventHandlerDryRunRequest?: EventHandlerDryRunRequest, options?: RequestInit) => {

        return customFetcher(getEventHandlerDryRunUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(eventHandlerDryRunRequest)
  }
);
      }
  }


export type eventHandlerExecutionsResponse200 = {
  data: ApiEnvelopeEventExecutionListResponse
  status: 200
}

export type eventHandlerExecutionsResponse403 = {
  data: ApiEnvelopeEventExecutionListResponse
  status: 403
}

export type eventHandlerExecutionsResponse404 = {
  data: ApiEnvelopeEventExecutionListResponse
  status: 404
}

export type eventHandlerExecutionsResponseSuccess = (eventHandlerExecutionsResponse200) & {
  headers: Headers;
};
export type eventHandlerExecutionsResponseError = (eventHandlerExecutionsResponse403 | eventHandlerExecutionsResponse404) & {
  headers: Headers;
};

export type eventHandlerExecutionsResponse = (eventHandlerExecutionsResponseSuccess | eventHandlerExecutionsResponseError)

export const getEventHandlerExecutionsUrl = (botId: string,
    params?: EventHandlerExecutionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/bots/${botId}/automation/executions?${stringifiedParams}` : `/api/bots/${botId}/automation/executions`
}

export const useEventHandlerExecutionsHook = (): (botId: string,
    params?: EventHandlerExecutionsParams, options?: RequestInit) => Promise<eventHandlerExecutionsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    params?: EventHandlerExecutionsParams, options?: RequestInit) => {

        return customFetcher(getEventHandlerExecutionsUrl(botId,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


